var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSliders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9685 15.3879L18.9685 30.5754",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9685 5.82544L18.9685 9.76294",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9685 15.3879C20.5218 15.3879 21.781 14.1287 21.781 12.5754C21.781 11.0221 20.5218 9.76294 18.9685 9.76294C17.4152 9.76294 16.156 11.0221 16.156 12.5754C16.156 14.1287 17.4152 15.3879 18.9685 15.3879Z",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0935 26.6379L29.0936 30.5754",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0936 5.82544L29.0935 21.0129",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0935 26.6379C30.6468 26.6379 31.906 25.3787 31.906 23.8254C31.906 22.2721 30.6468 21.0129 29.0935 21.0129C27.5402 21.0129 26.281 22.2721 26.281 23.8254C26.281 25.3787 27.5402 26.6379 29.0935 26.6379Z",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84334 22.1379L8.84326 30.5754",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84326 5.82544L8.84334 16.5129",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84351 22.1379C10.3968 22.1379 11.656 20.8787 11.656 19.3254C11.656 17.7721 10.3968 16.5129 8.84351 16.5129C7.29021 16.5129 6.03101 17.7721 6.03101 19.3254C6.03101 20.8787 7.29021 22.1379 8.84351 22.1379Z",
    stroke: "#339EEC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliders);
export default __webpack_public_path__ + "static/media/Sliders.c12c14e4e71f7ea7ca5369552a5c8b96.svg";
export { ForwardRef as ReactComponent };